import { useQuery } from '@tanstack/react-query';

import { organisationApi, organisationKeys, type Organisation } from '@/entities/order';
import { useSessionStore } from '@/shared/api';

/**
 * De actieve omgeving, voor de kopbalk van elk scherm.
 *
 * De sessie draagt de omgeving (naam en logo uit `GET /auth/me`, gezet door de
 * schil). Staat hij daar, dan is dat de bron - geen eigen verzoek per kopbalk.
 * Alleen zolang de sessie hem nog niet kent valt de hook terug op `GET /tenant`.
 *
 * Deze hook toont alleen; wisselen van omgeving doet het gebruikersblok in de
 * rail.
 */
export function useOrganisation(): Organisation | null {
    const tenant = useSessionStore((state) => state.session?.tenant ?? null);

    const { data } = useQuery({
        queryKey: organisationKeys.current(),
        queryFn: () => organisationApi.current(),
        staleTime: 30 * 60 * 1_000,
        enabled: tenant === null,
    });

    if (tenant) {
        return { id: tenant.uuid, name: tenant.name, logo_url: tenant.logoUrl };
    }

    return data ?? null;
}
